import { Attachment as AttachmentEntity } from '@/app/entities/Training'
import { cn } from '@/app/utils/cn'
import { download } from '@/app/utils/download'
import { Button } from '@/view/components/ui/button'
import { Download } from 'lucide-react'
import { getIconComponent } from '../ClassDetails/components/FilesDropzone'

interface AttachmentProps {
  attachment: AttachmentEntity
}

export function Attachment({ attachment }: AttachmentProps) {
  return (
    <div
      key={attachment.name}
      className={cn(
        'flex w-full items-center justify-between rounded-md border p-5',
      )}
    >
      <div className="flex items-center space-x-2">
        {getIconComponent(attachment.url)}
        <p className="max-w-[164px] truncate">{attachment.name}</p>
      </div>
      <div className="flex items-center text-muted-foreground">
        <span className="mr-2 text-xs">
          {/* {(value?.file?.size / 1024 / 1024).toFixed(2)} MB */}
        </span>
        <Button
          size="icon"
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation()
            download(attachment.url, attachment.name)
          }}
        >
          <Download size={24} />
        </Button>
      </div>
    </div>
  )
}
